import { cloneDeep } from 'lodash';
import { Observable, Subject } from 'rxjs'
import { Injectable } from '@angular/core'

import { AnalyticsApiService, Query, Rollup, ColorService, SessionService, MessageService } from '@hub-components'

import { DashboardWidget, Layout } from '../models/dashboard-widget.model'

@Injectable()
export class WidgetService {
  private datasets: any[] = []
  private colors: string[]
  zoomed: Subject<Boolean> = new Subject<Boolean>()

  constructor(
    private analyticsApi: AnalyticsApiService,
    private colorService: ColorService,
    private sessionService: SessionService,
  ) {
    this.colors = this.colorService.defaultColors.slice(0, 10)
    if (!this.sessionService.isPublic) {
      this.analyticsApi
        .loadDatasets({ cache: true })
        .subscribe(datasets => {
          this.datasets = datasets
          const dataset = this.datasets[0];
          if (dataset) {
            this.analyticsApi.loadSchema(dataset.name, { cache: true, skipLoader: true }).subscribe(schema => dataset.schema = schema)
          }
        })
    }
  }

  create(type: string, interval: string): DashboardWidget {
    let layout = new Layout({ width: 0, height: 0, x: 0, y: 0 })
    let query = this.defaultQuery(type, interval)
    let style
    if (type === 'kpi' || type === 'dimension-value') {
      style = {
        baseColor: this.colors[Math.floor(Math.random() * this.colors.length)],
      }
    }
    return new DashboardWidget(type, layout, {}, query, undefined, style)
  }

  duplicate(widget: DashboardWidget, layoutOffset: boolean = true): DashboardWidget {
    let query = widget.query.clone();
    let offset = layoutOffset ? 40 : 0
    let layout = new Layout({width: widget.layout.width, height: widget.layout.height, x: widget.layout.x + offset, y: widget.layout.y + offset})
    let newWidget = new DashboardWidget(widget.type, layout, widget.inputs, query, cloneDeep(widget.options), cloneDeep(widget.style))
    return newWidget
  }

  defaultQuery(type: string, interval: string): Query | undefined {
    const defaultRollups = {
      line: 'day',
      kpi: 'total',
      bar: 'total',
      pie: 'total',
      area: 'day',
      table: 'total',
      combo: 'day',
    }
    const dataset = this.datasets[0];
    if (dataset && dataset.schema) {
      const schema = dataset.schema
      let defaultQuery = {
        dataset: dataset.name,
        dimensions: ['entity'],
        rollup: defaultRollups[type],
        interval: interval
      }
      return new Query(defaultQuery, schema)
    }
  }

  triggeredZoomed() {
    this.zoomed.next(true)
  }
}
